import { Text } from "@overmap-ai/blocks"
import { type IssueType } from "@overmap-ai/common"
import { selectIssueTypeById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { IssueTypeIcon } from "../../../../components/Icons/IssueTypeIcon"
import { useAppSelector } from "../../../../store"

export const IssueTypeMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: IssueType["uuid"] }

	const issueType = useAppSelector(selectIssueTypeById(uuid))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!issueType && (
				<Link
					className="whitespace-nowrap"
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/issue-types/$issueTypeId"
					params={(prev) => ({ ...prev, issueTypeId: issueType.uuid })}
				>
					<IssueTypeIcon issueTypeId={issueType.uuid} background={false} className="align-sub" />
					<Text className="truncate">{issueType.name}</Text>
				</Link>
			)}
		</NodeViewWrapper>
	)
})
IssueTypeMentionComponent.displayName = "IssueTypeMentionComponent"
